module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-411x93@1x.5bf03959.jpg";